const icon = require('vue-svgicon');
icon.register({
    'intelinvest': {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        data: `<path fill-rule="evenodd" clip-rule="evenodd" _fill="#000" d="M21.3,5.4c1.5,0,2.7-1.2,2.7-2.7S22.8,0,21.3,0 s-2.7,1.2-2.7,2.7S19.8,5.4,21.3,5.4z"/><path fill-rule="evenodd" clip-rule="evenodd" _fill="#000" d="M16.4,6.4H1.2c-0.5,0-0.9,0.3-1.1,0.7C0,7.6,0.1,8.1,0.4,8.4 L3.9,12l-3.6,3.6h0c-0.4,0.5-0.4,1.2,0,1.6c0.5,0.5,1.2,0.5,1.7,0l0.1-0.1v0l4.3-4.3c0.5-0.5,0.5-1.2,0-1.7L4.1,8.8h9.5L0.4,22 c-0.3,0.3-0.4,0.8-0.3,1.3S0.7,24,1.2,24h6.5c0.3,0,0.6-0.1,0.8-0.3l3.5-3.5l3.5,3.5c0.3,0.3,0.8,0.4,1.3,0.3 c0.4-0.2,0.7-0.6,0.7-1.1V7.6C17.6,7,17.1,6.4,16.4,6.4z M15.2,20l-2.3-2.3c-0.2-0.2-0.5-0.3-0.8-0.3c-0.3,0-0.6,0.1-0.8,0.3l-4,4 H4.1l11.2-11.2V20z" />`,
    },
});
